import AxiosConfig from '@/config/axios-config'

export const LtiAPI = {

  urlIntegracaoLti (launchData) {
    return AxiosConfig.ltiAPI().post('/lti', launchData).then(response => response.data)
  }

}

export default LtiAPI
